// extracted by mini-css-extract-plugin
export default {"background":"UltimateBackground_background__f2GzS","image":"UltimateBackground_image__HdIIv"};